import { MysqlIconUrl } from "@p0security/shared/integrations/constants";
import { MysqlComponents } from "@p0security/shared/integrations/resources/mysql/components";

import { Install, InstallProps } from "../Install/Install";
import { mysqlInstaller } from "./install";

const identifier = () => "identifier";
const itemKind = () => "instance";

export const Mysql = (
  props: Pick<
    InstallProps<typeof MysqlComponents>,
    "cardOverride" | "onInstall"
  >
) => (
  <Install<typeof MysqlComponents>
    components={MysqlComponents}
    installer={mysqlInstaller}
    integration="mysql"
    itemKind={itemKind}
    identifier={identifier}
    logo={MysqlIconUrl}
    title="MySQL"
    {...props}
  />
);
